"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_ilx8rmp2a = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/UserMenu.js";
  var hash = "8b75a8921d795306c9cd34a9afb0f7db8bfda4db";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/UserMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 14,
          column: 29
        }
      },
      "1": {
        start: {
          line: 15,
          column: 47
        },
        end: {
          line: 15,
          column: 86
        }
      },
      "2": {
        start: {
          line: 16,
          column: 28
        },
        end: {
          line: 16,
          column: 43
        }
      },
      "3": {
        start: {
          line: 17,
          column: 21
        },
        end: {
          line: 17,
          column: 42
        }
      },
      "4": {
        start: {
          line: 17,
          column: 27
        },
        end: {
          line: 17,
          column: 42
        }
      },
      "5": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 40
        }
      },
      "6": {
        start: {
          line: 18,
          column: 26
        },
        end: {
          line: 18,
          column: 40
        }
      },
      "7": {
        start: {
          line: 20,
          column: 17
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "8": {
        start: {
          line: 24,
          column: 30
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "9": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 43,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "UserMenu",
        decl: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 13,
            column: 17
          }
        },
        loc: {
          start: {
            line: 13,
            column: 20
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 21
          },
          end: {
            line: 17,
            column: 22
          }
        },
        loc: {
          start: {
            line: 17,
            column: 27
          },
          end: {
            line: 17,
            column: 42
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 21
          }
        },
        loc: {
          start: {
            line: 18,
            column: 26
          },
          end: {
            line: 18,
            column: 40
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 47
          },
          end: {
            line: 15,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 47
          },
          end: {
            line: 15,
            column: 80
          }
        }, {
          start: {
            line: 15,
            column: 84
          },
          end: {
            line: 15,
            column: 86
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 17
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 60
          },
          end: {
            line: 20,
            column: 94
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 107
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }, {
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 56
          }
        }],
        line: 20
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 30
          },
          end: {
            line: 30,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 24,
            column: 41
          },
          end: {
            line: 24,
            column: 46
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 29,
            column: 12
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "8b75a8921d795306c9cd34a9afb0f7db8bfda4db"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _useStyles = require("./useStyles");

var _ = require("..");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function UserMenu() {
  cov_ilx8rmp2a.f[0]++;
  var classes = (cov_ilx8rmp2a.s[0]++, (0, _useStyles.useStyles)());

  var _ref = (cov_ilx8rmp2a.s[1]++, (cov_ilx8rmp2a.b[0][0]++, (0, _react.useContext)(_.AuthenticationContext)) || (cov_ilx8rmp2a.b[0][1]++, {})),
      authentication = _ref.state,
      component = _ref.component;

  var _ref2 = (cov_ilx8rmp2a.s[2]++, (0, _react.useState)(false)),
      _ref3 = _slicedToArray(_ref2, 2),
      modal = _ref3[0],
      setModal = _ref3[1];

  cov_ilx8rmp2a.s[3]++;

  var closeModal = function closeModal() {
    cov_ilx8rmp2a.f[1]++;
    cov_ilx8rmp2a.s[4]++;
    return setModal(false);
  };

  cov_ilx8rmp2a.s[5]++;

  var openModal = function openModal() {
    cov_ilx8rmp2a.f[2]++;
    cov_ilx8rmp2a.s[6]++;
    return setModal(true);
  };

  var avatar = (cov_ilx8rmp2a.s[7]++, !((cov_ilx8rmp2a.b[2][0]++, authentication) && (cov_ilx8rmp2a.b[2][1]++, authentication.user)) ? (cov_ilx8rmp2a.b[1][0]++, /*#__PURE__*/_react.default.createElement(_icons.AccountCircle, {
    fontSize: "large"
  })) : (cov_ilx8rmp2a.b[1][1]++, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    "data-test": "user-menu-avatar",
    className: classes.avatar,
    src: authentication.user.avatar_url
  })));
  var authenticationModal = (cov_ilx8rmp2a.s[8]++, !modal ? (cov_ilx8rmp2a.b[3][0]++, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)) : (cov_ilx8rmp2a.b[3][1]++, /*#__PURE__*/_react.default.createElement(_core.Modal, {
    open: true,
    onClose: closeModal
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.modal
  }, component))));
  cov_ilx8rmp2a.s[9]++;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "data-test": "user-menu-icon",
    onClick: openModal,
    color: "inherit"
  }, avatar), authenticationModal);
}

;
var _default = UserMenu;
exports.default = _default;